import { Input } from '@builder.io/sdk';

import { buttonFields } from 'molecules/Button/config';

const pricingCardFields = [
  { name: 'planName', type: 'string', defaultValue: 'Pro' },
  {
    name: 'description',
    type: 'longText',
    defaultValue: 'Everything you need to build and deploy embedded integrations to your customers.',
  },
  { name: 'highlighted', type: 'boolean', defaultValue: false },
  {
    name: 'details',
    type: 'list',
    subFields: [
      { name: 'detail', type: 'string', defaultValue: 'Build unlimited integrations' },
      { name: 'description', type: 'string', helperText: 'Optional description that is rendered in a tooltip' },
    ],
  },
  ...buttonFields,
  {
    name: 'chiliPiperUrl',
    type: 'string',
    helperText:
      'Chili Piper Router Link URL. When set, the button opens this URL in a popup window instead of navigating to the link above.',
  },
] as const satisfies DeepReadonly<Input[]>;

export type PricingCardConfigProps = GenerateBuilder<typeof pricingCardFields>;

export default pricingCardFields;
